var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "同步详情",
        visible: _vm.open,
        width: "900px",
        "append-to-body": "",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.open = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "sync-detail",
        },
        [
          _c(
            "el-card",
            { staticClass: "detail-card", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "card-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("i", { staticClass: "el-icon-info" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("基本信息")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-descriptions",
                { attrs: { column: 3, border: "" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "同步类型" } },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.getSyncTypeTagType(_vm.syncInfo.syncType),
                            size: "small",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.getSyncTypeText(_vm.syncInfo.syncType)
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "同步方式" } },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type:
                              _vm.syncInfo.syncMethod === "manual"
                                ? "warning"
                                : "info",
                            size: "small",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.syncInfo.syncMethod === "manual"
                                  ? "手动同步"
                                  : "定时同步"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "同步状态" } },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.getStatusTagType(_vm.syncInfo.status),
                            size: "small",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getStatusText(_vm.syncInfo.status)) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "总记录数" } }, [
                    _c("span", { staticClass: "number-text" }, [
                      _vm._v(_vm._s(_vm.syncInfo.totalCount || 0)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "成功记录数" } },
                    [
                      _c("span", { staticClass: "success-text" }, [
                        _vm._v(_vm._s(_vm.syncInfo.successCount || 0)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "失败记录数" } },
                    [
                      _c("span", { staticClass: "failed-text" }, [
                        _vm._v(_vm._s(_vm.syncInfo.failedCount || 0)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "成功率", span: 3 } },
                    [
                      _c(
                        "div",
                        { staticClass: "progress-container" },
                        [
                          _c("el-progress", {
                            attrs: {
                              percentage: _vm.getSuccessRate(_vm.syncInfo),
                              color: _vm.getProgressColor(_vm.syncInfo),
                              "show-text": true,
                              format: function (percentage) {
                                return (
                                  percentage +
                                  "% (" +
                                  _vm.syncInfo.successCount +
                                  "/" +
                                  _vm.syncInfo.totalCount +
                                  ")"
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "开始时间" } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.syncInfo.createTime) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "结束时间" } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.syncInfo.endTime || "进行中") +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-descriptions-item", { attrs: { label: "耗时" } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.getDuration(_vm.syncInfo)) +
                        "\n        "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.syncInfo.logs && _vm.syncInfo.logs.length > 0
            ? _c(
                "el-card",
                { staticClass: "detail-card", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("i", { staticClass: "el-icon-document" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("执行日志")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "log-container" },
                    _vm._l(_vm.syncInfo.logs, function (log, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "log-item",
                          class: _vm.getLogClass(log.level),
                        },
                        [
                          _c("div", { staticClass: "log-time" }, [
                            _vm._v(_vm._s(_vm.formatTime(log.time))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "log-level" },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.getLogTagType(log.level),
                                    size: "mini",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(log.level.toUpperCase()) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "log-message" }, [
                            _vm._v(_vm._s(log.message)),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.syncInfo.errorInfo
            ? _c(
                "el-card",
                { staticClass: "detail-card", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("i", { staticClass: "el-icon-warning" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("错误信息")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "error-container" },
                    [
                      _c("el-alert", {
                        attrs: {
                          title: "同步失败",
                          type: "error",
                          description: _vm.syncInfo.errorInfo,
                          "show-icon": "",
                          closable: false,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.syncInfo.details && _vm.syncInfo.details.length > 0
            ? _c(
                "el-card",
                { staticClass: "detail-card", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("i", { staticClass: "el-icon-data-line" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("同步详情")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.syncInfo.details,
                        border: "",
                        stripe: "",
                        size: "small",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "序号",
                          type: "index",
                          width: "60",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "记录ID",
                          prop: "recordId",
                          width: "100",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "记录名称",
                          prop: "recordName",
                          "min-width": "150",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "操作类型",
                          prop: "operationType",
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: _vm.getOperationTagType(
                                          scope.row.operationType
                                        ),
                                        size: "mini",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.getOperationText(
                                              scope.row.operationType
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1730469103
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "状态",
                          prop: "status",
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row.status === "success"
                                            ? "success"
                                            : "danger",
                                        size: "mini",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row.status === "success"
                                              ? "成功"
                                              : "失败"
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1891026363
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "错误信息",
                          prop: "errorMessage",
                          "min-width": "200",
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.errorMessage
                                    ? _c(
                                        "span",
                                        { staticClass: "error-message" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(scope.row.errorMessage) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "success-message" },
                                        [_vm._v("-")]
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4269543463
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "处理时间",
                          prop: "processTime",
                          width: "160",
                          align: "center",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.open = false
                },
              },
            },
            [_vm._v("关 闭")]
          ),
          _vm._v(" "),
          _vm.syncInfo.status === "failed"
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleRetry } },
                [_vm._v("\n      重试同步\n    ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }